// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.

enum RefundDisplayStatus {
  Unknown = "UNKNOWN",
  Candidate = "CANDIDATE",
  Created = "CREATED",
  Rejected = "REJECTED",
  Incompletable = "INCOMPLETABLE",
  Approved = "APPROVED",
  Failed = "FAILED",
  InProgress = "IN_PROGRESS",
  Completed = "COMPLETED",
  RefundOfRefund = "REFUND_OF_REFUND",
}
export default RefundDisplayStatus;

export function refundDisplayStatusVariant(refundDisplayStatus: RefundDisplayStatus) {
  switch (refundDisplayStatus) {
    case RefundDisplayStatus.Created:
      return "black";

    case RefundDisplayStatus.Completed:
      return "success";

    case RefundDisplayStatus.InProgress:
      return "warning";

    case RefundDisplayStatus.Failed:
    case RefundDisplayStatus.RefundOfRefund:
    case RefundDisplayStatus.Rejected:
      return "danger";

    default:
      return "black";
  }
}
